import { Button, Result } from 'antd';
import React from 'react';
import ErrorIcon from '../assets/images/error-icon.png';
const languageOptions = {
    zh:{
        errText:'页面加载出错，请检查网络连接并刷新重试',
        reloadText:'刷新页面'
    },
    en:{
        errText:'Page loading error, please check the network connection and refresh to try again',
        reloadText:'Refresh page'
    }
}
class ErrorPage extends React.Component {
  state = { hasError: false, errorInfo: ''};

  static getDerivedStateFromError(error) {
    return { hasError: true, errorInfo: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.log(error, errorInfo);
  }
  language = localStorage.getItem('language')
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Result
          icon={
            <img
              style={{transform:'translateX(8px)'}}
              width={256}
              src={ErrorIcon}
            />
          }
          style={{
            height: '100%',
            background: '#fff',
          }}
          title={languageOptions[this.language].errText}
          extra={
            <>
              <Button
                danger
                type="primary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                {languageOptions[this.language].reloadText}
              </Button>
            </>
          }
        />
      );
    }
    return <>
      {this.props.children}
        <img
          style={{display:'none'}}
          src={ErrorIcon}
        />
    </>;
  }
}
export default ErrorPage;